export default {
    label_task:{
        en:"Variety Sub Types",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Sub Types",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Sub Types",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Sub Types",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}